<form [formGroup]="residentialAddressForm" >
    <div class="step-container">
       <!--<div class="step-title">{{ getTranslation('address.title') }}</div> -->
      
      <!-- Language Selector -->
 

      <div *ngIf="isJsonShow">
        {{residentialAddressForm.value | json}}

      </div>
   

      <div class="row gx-2">
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputStreetAddress" class="form-label">{{ getTranslation('address.streetAddress') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputStreetAddress" formControlName="StreetAddress" [placeholder]="getTranslation('address.enterStreetAddress')"  [maxlength]="CONSTANTS.MaxLength.inputField" >
          <div *ngIf="submitted && residentialAddressForm.controls['StreetAddress'].invalid" class="text-danger">
            {{ getTranslation('validation.streetAddressRequired') }}
          </div>
        </div>
  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputTownCity" class="form-label">{{ getTranslation('address.townCity') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputTownCity" formControlName="TownCity" [placeholder]="getTranslation('address.enterTownCity')"  [maxlength]="CONSTANTS.MaxLength.inputField" >
          <div *ngIf="submitted && residentialAddressForm.controls['TownCity'].invalid" class="text-danger">
            {{ getTranslation('validation.townCityRequired') }}
          </div>
        </div>
  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputDistrict" class="form-label">{{ getTranslation('address.district') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputDistrict" formControlName="District" [placeholder]="getTranslation('address.enterDistrict')" (keypress)="genericValidations.onlyLettersValidator($event)" [maxlength]="CONSTANTS.MaxLength.inputField" >
          <div *ngIf="submitted && residentialAddressForm.controls['District'].invalid" class="text-danger">
            {{ getTranslation('validation.districtRequired') }}
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <!-- <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputState" class="form-label">State: <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputState" formControlName="State" placeholder="Enter State"  maxlength="50" >
          <div *ngIf="submitted && residentialAddressForm.controls['State'].invalid" class="text-danger">
            State is required.
          </div>
        </div> -->


        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputState" class="form-label">{{ getTranslation('address.state') }} <span class="text-danger">*</span></label>
          <select class="form-control" id="inputState" formControlName="State" required>
            <option value="" disabled selected>{{ getTranslation('address.selectState') }}</option>
            <option *ngFor="let state of indianStateOptions" [value]="state.id">{{ state.name }}</option>
          </select>
          <div *ngIf="submitted && residentialAddressForm.controls['State'].invalid" class="text-danger">
            {{ getTranslation('validation.stateRequired') }}
          </div>
        </div>


  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputPinCode" class="form-label">{{ getTranslation('address.pinCode') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputPinCode" formControlName="PinCode" [placeholder]="getTranslation('address.enterPinCode')" maxlength="6"  (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
          <div *ngIf="submitted && residentialAddressForm.controls['PinCode'].invalid" class="text-danger">
            {{ getTranslation('validation.pinCodeRequired') }}
          </div>
        </div>
  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputHomePhone" class="form-label">{{ getTranslation('address.mobilePersonal') }}:</label>
          <div class="d-flex">
            <div class="country-code-container">
              <ng-select
                formControlName="CountryCode"
                [items]="countryCodeOptions"
                bindLabel="code"
                bindValue="code"
                [searchable]="true"
                [searchFn]="searchCountry"
                [clearable]="false"
                [placeholder]="getTranslation('address.selectCountry')"
                (change)="onCountryCodeChange($event)">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
              </ng-select>
            </div>
            <input type="text" class="form-control mobile-number-input" id="inputHomePhone" formControlName="Mobile" 
              [placeholder]="getTranslation('address.enterHomePhone')" maxlength="15"  (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
          </div>
          <div *ngIf="submitted && residentialAddressForm.controls['CountryCode'].invalid" class="text-danger">
            <span *ngIf="residentialAddressForm.controls['CountryCode'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
          </div>
          <div *ngIf="submitted && residentialAddressForm.controls['Mobile'].invalid" class="text-danger">
            <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['required']">{{ getTranslation('validation.mobileRequired') }}</span>
            <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
            <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
          </div>
        </div>
  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputWorkPhone" class="form-label">{{ getTranslation('address.mobileAlternate') }}:</label>
          <input type="text" class="form-control" id="inputWorkPhone" formControlName="WorkPhone" [placeholder]="getTranslation('address.enterWorkPhone')" maxlength="10" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
        </div>
  
        <!-- <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputMobile" class="form-label">Mobile: <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="inputMobile" formControlName="Mobile" placeholder="Enter Mobile Number" maxlength="10" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
          <div *ngIf="submitted && residentialAddressForm.controls['Mobile'].invalid" class="text-danger">
            Mobile is required and must be 10 digits.
          </div>
        </div> -->
  
        <!-- <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputGspId" class="form-label">GSP ID # if known:</label>
          <input type="text" class="form-control" id="inputGspId" formControlName="GspId" placeholder="Enter GSP ID"  maxlength="50" >
        </div> -->
  
        <div class="form-group col-12 col-md-4 mb-3">
          <label for="inputEmail" class="form-label">{{ getTranslation('address.email') }}:</label>
          <input type="Email" class="form-control" id="inputEmail" formControlName="Email" [placeholder]="getTranslation('address.enterEmail')"   maxlength="50" >
          <!-- <div *ngIf="submitted && residentialAddressForm.controls['Email'].invalid" class="text-danger">
            Valid Email is required.
          </div> -->
        </div>
      </div>
  
    
    </div>
    <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive"*ngIf="!isPreviewMode">
    <button type="button" style="display: none;" class="btn savedraftbtn" 
            *ngIf="residentialAddressForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT,'CHILD')">
      <i class="fas fa-save mr-2"></i>SAVE AS DRAFT
    </button>
    <!-- <button type="button" class="btn prevbtn" (click)="goToBack()">
      PREVIOUS
    </button> -->
    <!-- <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE,'CHILD')">
      <i class="fas fa-save mr-2 "></i>{{ getTranslation('button.saveAsDraft') }}
    </button> -->
  </div>
   <!-- Buttons ends -->
  </form>
  